import moment from 'moment';
import i18n from 'i18next';

const second = 1000;
const minute = second * 60;
const hour = minute * 60;
const oneDay = hour * 24;

const relativeDate = (delta: number)  => {
  switch( true ){
    case delta > 0 && delta <= minute: {
      return i18n.t('Updated less than a minute ago');
    }
    case delta > minute && delta <= hour: {
      return i18n.t('Last updated minutes', { count: Math.floor(delta / minute) });
    }
    case delta > hour && delta <= oneDay: {
      const hours = Math.floor(delta / hour);
      return i18n.t('Last updated hours', { count: hours });
    }
    default:
      return ""
  }
};

export const flattenDate = (date: string) => {
  const universal = moment.utc(date).toDate().getTime();
  const delta = new Date().getTime() - universal;
  if (delta >= oneDay) {
    return `${i18n.t('Last updated at')} ${moment(date).format('LLL')}`;
  } else {
    return relativeDate(delta);
  }
};